export const ERROR_MAPPING = {
  phone: "form-contact",
  email: "form-contact",
  department: "form-ubigeo",
  province: "form-ubigeo",
  district: "form-ubigeo",
  address: "form-ubigeo",
  job: "form-job",
  isWorking: "form-job",
  company: "form-job",
};